// extracted by css-extract-rspack-plugin
export default {"cameraRoot":"PicFromFileOrCam_cameraRoot__5aCki","cameraCloseButton":"PicFromFileOrCam_cameraCloseButton__csYUn"};